module.exports = __webpack_public_path__ + "media/rugPull.1fcb5295.mp3";